require('../base');

$(function () {
});